import { Component } from '@theme/component';
import PaginatedList from '@theme/paginated-list';

/**
 * Blog archive: optional infinite scroll, or classic pagination (Liquid + pagination-controls).
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    if (this.getAttribute('infinite-scroll') === 'false') {
      Component.prototype.connectedCallback.call(this);
      return;
    }
    super.connectedCallback();
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
